import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { svgIconStyles as s } from "../svg-icon/SvgIcon.styles.js";
function f({
  label: r,
  className: o,
  size: t,
  ...i
}) {
  return /* @__PURE__ */ n(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "arrowLeft",
      stroke: "none",
      role: "img",
      "aria-hidden": !r,
      focusable: "false",
      className: s({ className: o, size: t }),
      ...i,
      children: [
        r && /* @__PURE__ */ e("title", { children: r }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M17 20.6959C17 21.5778 15.9516 22.039 15.3015 21.443L5 12L15.3015 2.55695C15.9516 1.96101 17 2.42219 17 3.30412C17 3.58824 16.8808 3.85931 16.6713 4.05129L8.16083 11.8526C8.07436 11.9318 8.07436 12.0682 8.16083 12.1474L16.6713 19.9487C16.8808 20.1407 17 20.4118 17 20.6959Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  f as ArrowLeftIcon,
  f as default
};
